module.exports = __webpack_public_path__ + "static/media/Data Upload Templates - Amazon UAE.f066b145.xlsx";